import BannerTitleButton from "./BannerTitleButton";

const NoDiscountsBanner = () => {
    const imageSrc = `${window._env_.STATIC_HOST}/static/website/images/nodiscount-banner.webp`;

    return (
        <BannerTitleButton
            imageDesktop={imageSrc}
            imageMobile={imageSrc}
            subtitle={"En este momento no hay promociones disponibles. <br> Muy pronto presentaremos nuevos beneficios."}
            title={"Beneficios exclusivos <br> en camino"}
            color="white"
            buttons={[
                {
                    config: {
                        tag: "button-link",
                        text: "Volver al inicio",
                        color: "white",
                        url: "/",
                    },
                },
            ]}
            extraClass="--with-margin-top --discounts-empty-fullscreen"
            forceNoRepeatBackground={true}
        />
    );
};

export default NoDiscountsBanner;
